import TemplateView from '../../../../TemplateView'

export default class ItemsList extends TemplateView {
    constructor({
        items = [],
    }) {
        super(null)

        this.items = items
    }

    templateHtml() {
        return '<div class="list"></div>'
    }

    afterRender() {
        this.items.forEach(item => {
            item.init(this.$el)
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/itemsFilter/ItemsList.js